// https://medium.com/analytics-vidhya/how-to-post-and-fetch-data-using-react-query-4c3280c0ef96
import { ThemeProvider } from '@mui/material/styles';
import { createRoot } from 'react-dom/client';
import { App } from './app';
import './styles.scss';
import { theme } from './theme';

const root = createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>,
);
